export enum CartNotificationType {
  Error = 'error',
  Warning = 'warning'
}

export enum CartNotificationRule {
  ProductNotFound = 'ProductNotFound',
  ProductNotFoundWithSupersede = 'ProductNotFoundWithSupersede',
  ProductIsNew = 'ProductIsNew',
  ProductIsNewWithSupersede = 'ProductIsNewWithSupersede',
  ProductDiscontinued = 'ProductDiscontinued',
  ProductDiscontinuedWithSupersede = 'ProductDiscontinuedWithSupersede',
  ProductRestricted = 'ProductRestricted',
  ProductRestrictedWithSupersede = 'ProductRestrictedWithSupersede',
  PriceNotFound = 'PriceNotFound',
  PriceIsZero = 'PriceIsZero',
  PriceExpired = 'PriceExpired',
  PriceExpiredWithSupersede = 'PriceExpiredWithSupersede',
  SupersedeWarning = 'SupersedeWarning'
}

export type CartNotificationAction = 'Remove' | 'Replace' | 'Keep';

export interface B2bCartNotification {
  itemNumber: string;
  title: string;
  description?: string;
  actions: CartNotificationAction[];
  type: CartNotificationType;
  rule: CartNotificationRule;
}
